// extracted by mini-css-extract-plugin
export default {"meter":"EvalueMeter_meter__4MCTS","meterBox":"EvalueMeter_meterBox__nvYPc","metercontainer":"EvalueMeter_metercontainer__CILd9","metertext":"EvalueMeter_metertext__jA534"};